import { Check, Timer } from "lucide-react";
import { UserAvatar } from "@/components/UserBits";

export function DuelOpponent({ side, maxTries, label }) {
  return (
    <div className={`flex items-center gap-3 rounded-2xl px-3 py-2.5 ${side.cracked ? "bg-emerald-500/20 ring-1 ring-emerald-400/50" : "bg-white/5"}`} data-testid={`vault-duel-side-${label}`}>
      <UserAvatar userId={side.user?.user_id} name={side.user?.name} picture={side.user?.picture} size="w-10 h-10" text="text-sm" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold truncate">{side.user?.name || "Spieler"}</p>
        <p className="text-xs text-white/60 tabular-nums" data-testid={`vault-duel-tries-${label}`}>{side.tries}/{maxTries} Versuche</p>
      </div>
      {side.cracked
        ? <span className="inline-flex items-center gap-1 text-xs font-extrabold text-emerald-300 vault-pop"><Check className="w-4 h-4" /> Geknackt</span>
        : <span className="flex gap-1" title="Bester Versuch">{[0, 1, 2, 3].map((i) => <span key={`${i}-${side.best}`} className={`w-3 h-3 rounded-full ${i < side.best ? "bg-amber-400 shadow-[0_0_8px_rgba(251,191,36,0.8)] vault-peg-in" : "bg-white/10"}`} />)}</span>}
    </div>
  );
}

export function DuelTimer({ left, total }) {
  const pct = Math.max(0, Math.min(100, (left / total) * 100));
  const urgent = left <= 30;
  return (
    <div data-testid="vault-duel-timer">
      <div className="flex justify-between text-sm font-extrabold mb-1"><span className="flex items-center gap-1"><Timer className="w-4 h-4" /> Zeit</span><span className={`tabular-nums ${urgent ? "text-rose-300 animate-pulse" : "text-amber-200"}`}>{Math.floor(left / 60)}:{String(left % 60).padStart(2, "0")}</span></div>
      <div className="h-2 rounded-full bg-white/10 overflow-hidden"><div className={`h-full transition-[width] duration-1000 ease-linear ${urgent ? "bg-rose-500" : "bg-gradient-to-r from-amber-400 to-rose-500"}`} style={{ width: `${pct}%` }} /></div>
    </div>
  );
}
